import './index.scss';

import { useAuth } from 'admin/Auth';
import React from 'react';

import UserDropdown from './dropdown';
import Login from './login';

const UserInfo: React.FC = () => {
  const { user } = useAuth();
  return (
    <div className="info-wrap">
      {user?.phone ? <UserDropdown /> : <Login />}
    </div>
  );
};

export default UserInfo;
